import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectOnboardingFlow } from '../onboarding/orchestration/selectors';
import {
  routeToStepId,
  isOffboardingStep,
} from '../onboarding/orchestration/computeFlow';

const isUnsubSlugPage = (pathname: string) => /^\/unsub\/[^/]+$/.test(pathname);

const isPatientSatisfactionPage = (pathname: string) =>
  /^\/(patient-satisfaction|unsub-patient-satisfaction)\/[^/]+$/.test(pathname);

export const useShouldHideBackButton = () => {
  const location = useLocation();
  const flow = useSelector(selectOnboardingFlow);

  // Unsubscribe flow: hide back only on /unsub/:slug
  if (isUnsubSlugPage(location.pathname)) return true;
  if (isPatientSatisfactionPage(location.pathname)) return true;

  const stepId = routeToStepId(location.pathname);
  if (!stepId) return false;

  const index = flow.indexOf(stepId);
  if (index === -1) return false;

  // First page of the onboarding flow
  if (index === 0) return true;

  // Last page of the offboarding flow
  if (index === flow.length - 1 && isOffboardingStep(stepId)) return true;

  return false;
};
